import React from 'react';
import s from './VisuallyHidden.scss';

export interface Props {
  tag?: keyof React.JSX.IntrinsicElements;
  [key: string]: any;
}

/*
  Sometimes we need to include elements for accessibility reasons
  but design doesn't like those elements. So we use this component to
  make the element accessible to a screen reader, but hidden visually.
*/
const VisuallyHidden: React.FC<Props> = ({ tag = 'span', children, ...rest }) => {
  const Component = tag;

  return (
    <Component className={s['root']} {...rest}>
      {children}
    </Component>
  );
};
VisuallyHidden.displayName = 'VisuallyHidden';

export default VisuallyHidden;
